import styled from 'styled-components';

import { CARD_RATIO } from '~/src/common/components/GridCard/layout';

export const ProductPlaceholder = styled.div`
  border-radius: 8px;
  aspect-ratio: ${CARD_RATIO};
  background: ${({ theme }) => theme.palette.common.PLACEHOLDER};
`;
